<div class="draft-card">

  @let draft = draftWithdrawal();

  <div class="collaborator-section">
    <div class="collaborator-header">
      <liberro-avatar-photo
        [photoUrl]="null"
        fallbackType="user"
        size="48"
      ></liberro-avatar-photo>
      <div class="collaborator-info">
        <div class="collaborator-title">{{ 'moneyAndTransactions.regularWithdrawalDraftCard.title' | translate }}</div>
        <div class="collaborator-name">{{ collaboratorFullName() }}</div>
      </div>
    </div>
    <div class="collaborator-comment">
      <p #commentText class="comment-text" [innerHTML]="collaboratorCommentary()"></p>
      @if (isCommentClamped()) {
        <span class="read-comment-link" (click)="readFullComment.emit(collaboratorCommentary())">{{ 'moneyAndTransactions.regularWithdrawalDraftCard.wholeCommentLink' | translate }}</span>
     }
    </div>
  </div>

  <div class="divider"></div>

  <div class="investment-row">
    <div class="portfolio-info">
      <liberro-avatar-photo-tagged [portfolioDetail]="draftImageInfo()" size="44"></liberro-avatar-photo-tagged>

      <div class="portfolio-details">
        <div class="portfolio-name">{{ draft.portfolioName }}</div>
        @if (goalInfo().label && goalInfo().icon) {
          <div class="portfolio-goal">
            <svg-icon [src]="'assets/icons/' + goalInfo().icon" class="goal-icon"></svg-icon>
            <span class="goal-label">{{ goalInfo().label | translate }}</span>
          </div>
        }
      </div>
      <div class="expiry-badge-wrapper">
        <liberro-badge
          variant="danger"
          [label]="('investments.draftCard.expiresIn' | translate) + (draft.expiredAt | dayDiff)"
          [unbreakable]="true"
        ></liberro-badge>
      </div>
    </div>
  </div>

  <div class="details-section">
    <div class="detail-row">
      <span class="detail-label">{{ 'moneyAndTransactions.regularWithdrawalDraftCard.amount' | translate }}</span>
      <span class="detail-value">{{ draft.value | price: 'CZK' }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">{{ 'moneyAndTransactions.regularWithdrawalDraftCard.frequency' | translate }}</span>
      <span class="detail-value">
        {{ regularWithdrawalFrequencyMap!.get(draft.frequency)! | translate }}
      </span>
    </div>
    <div class="detail-row">
      <span class="detail-label">{{ 'moneyAndTransactions.regularWithdrawalDraftCard.validity' | translate }}</span>
      <span class="detail-value">
        {{ draft.validTo  ? (draft.validTo | date:'d. M. y') : ('moneyAndTransactions.regularWithdrawalDraftCard.unlimitedValidity' | translate) }}
      </span>
    </div>
    <div class="detail-row">
      <span class="detail-label">{{ 'moneyAndTransactions.regularWithdrawalDraftCard.account' | translate }}</span>
      <div class="bank-account">
        <img class="bank-logo" [src]="draft.logoUrl" />
        <span class="detail-value">{{ draft.accountNumber }}/{{ draft.bankCode }}</span>
      </div>
    </div>
  </div>

  <div class="actions-section">
    <liberro-button
      [label]="'global.button.refuse' | translate"
      type="default"
      widthType="width-100"
      (btnClick)="refuse.emit(draft.regularWithdrawalDraftId)"
    ></liberro-button>
    @if (draft.aml) {
      <liberro-button
        [label]="'global.button.accept' | translate"
        type="primary"
        widthType="width-100"
        [disabled]="waitingForMailConfirm() || isExpired()"
        nz-tooltip
        autoCloseOnScroll
        [nzTooltipTitle]="(waitingForMailConfirm() || isExpired()) ? acceptDisabledTooltip : null"
        nzTooltipOverlayClassName="lean"
        (btnClick)="accept.emit()"
      ></liberro-button>
      <ng-template #acceptDisabledTooltip>
        <liberro-tooltip-content>
            <div tooltipContent>
              @if (isExpired()) {
                <span>{{ 'moneyAndTransactions.regularWithdrawalDraftCard.regularDraftExpiredTooltip' | translate }}</span>
              }
              @if (waitingForMailConfirm()) {
                <span>{{ 'moneyAndTransactions.regularWithdrawalDraftCard.dipRegularDraftConfirmTooltip' | translate }}</span>
              }
            </div>
        </liberro-tooltip-content>
      </ng-template>
    } @else {
      <liberro-button
        [label]="'global.button.updateAml' | translate"
        type="primary"
        widthType="width-100"
        (btnClick)="updateAml.emit()"
      ></liberro-button>
    }
  </div>

</div>
